import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getVmsDefaultLandingPath, hasVmsRole } from '../utils/vmsRole';
import { PageLoader } from './LoadingStates';

/** VMS routes that require VMS role `admin` (dashboard, governance, user management). */
const VmsAdminRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return <PageLoader message="Loading..." />;
  }
  if (!hasVmsRole(user, 'admin')) {
    return <Navigate to={getVmsDefaultLandingPath(user)} replace />;
  }
  return <>{children}</>;
};

export default VmsAdminRoute;
